import { render, staticRenderFns } from "./transformData.vue?vue&type=template&id=e8d15c92&scoped=true&"
import script from "./transformData.vue?vue&type=script&lang=js&"
export * from "./transformData.vue?vue&type=script&lang=js&"
import style0 from "./transformData.vue?vue&type=style&index=0&id=e8d15c92&lang=scss&scoped=true&"
import style1 from "./transformData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d15c92",
  null
  
)

export default component.exports